import { render, staticRenderFns } from "./AccessBar.vue?vue&type=template&id=566b2b93&"
import script from "./AccessBar.vue?vue&type=script&lang=js&"
export * from "./AccessBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566b2b93')) {
      api.createRecord('566b2b93', component.options)
    } else {
      api.reload('566b2b93', component.options)
    }
    module.hot.accept("./AccessBar.vue?vue&type=template&id=566b2b93&", function () {
      api.rerender('566b2b93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/AccessBar/AccessBar.vue"
export default component.exports